define(['../../../vendor/lodash/collection.js'], function(_) {
    'use strict';
    return _.map;
});
